import qs from 'qs';

export const isHL = () => {
  return location.host === 'hl.qquanquan.com'
}
export const isJP = () => {
	return location.host === 'qm.qttunion.com'
}
export const isYX = () => {
	return location.host === 'qm.yunxish.com'
}
export const getPlatformTitle = () => {
  if (isHL()) return '海量'
  return '趣盟'
}
export const getICP = () => {
	if (isYX()) return [
		'© 沪ICP备2021007935号-1 上海芸晞信息科技有限公司，Shanghai yunxi Information Technology Co., Ltd. All Rights Reserved.',
		'上海市嘉定区真南路4268号(2幢JT21313室)'
	]
  if (isJP()) return [
	'© 2024上海姜盘信息科技有限公司,沪ICP备2024046462号-1, Shanghai Jangpan Information Technology Co., Ltd. All Rights Reserved.',
	'上海市嘉定区真南路4268号(2幢JT21313室)'
  ]
  if (isHL()) return [
    '© 2023 上海趣圈圈信息科技有限公司,沪ICP备19046668号-1,Shanghai Ququanquan Information Technology Co., Ltd. All Rights Reserved.',
    '上海市嘉定区真南路4268号2幢JT8944室'
  ]
  return [
    'Copyright © 2025 上海姜盘信息科技有限公司',
    '沪ICP备2024046462号-8'
  ]
}

export const isObject = (obj) =>
  Object.prototype.toString.call(obj) === '[object Object]';

export const isArray = (arr) =>
  Object.prototype.toString.call(arr) === '[object Array]';

export const isUrl = (str) =>
  /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/.test(
    str,
  );

export const on = (ele, evt, handle) =>
  ele && ele.addEventListener(evt, handle, false);

export const off = (ele, evt, handle) =>
  ele && ele.removeEventListener(evt, handle, false);

// simple valid. only support {} (no Function type)
export const isJson = (val) => {
  if (typeof val === 'string') {
    try {
      let obj = JSON.parse(val);
      return isObject(obj);
    } catch (e) {
      return false;
    }
  } else {
    return false;
  }
};

/**
 * @description openUrl 打开外部链接;
 * @param {String}  url
 * @param {Object}  query 参数
 * @param {Boolean} newWin 是否新开窗口/tab; defaults to false;
 * @param {Boolean} record 是否将该链接添加记录到history栈; defaults to false;
 * @return new window;
 */
export function openUrl(
  url = '',
  query = {},
  { newWin = false, record = false } = {},
) {
  let _url = url || '';

  // parse
  let [origin, search] = _url.split('?');
  let _query = qs.stringify({ ...qs.parse(search || ''), ...query });
  _url = `${origin}?${_query}`;

  if (newWin) {
    const win = window.open('', '_blank');
    win.location = _url;
  } else {
    if (!record) {
      location.href = _url;
    } else {
      location.assign(_url);
    }
  }
}

// 展开级联数据
export function expandCasc(data = []) {
  return data.reduce((r, v) => {
    r.push(v);
    if (v.children) {
      r.push(...expandCasc(v.children));
    }
    return r;
  }, []);
}

// 转为级联数据
export function toCasc(data = []) {
  return data.filter((item) => {
    const child = data.filter((i) => {
      return item.id === i.parent_id;
    });

    child.length && (item.children = child || []);
    return item.parent_id === 0;
  });
}

function addZero (num) {
	return (num > 9 ? '' : '0') + num;
}
function toFormat (date) {
	let y = date.getFullYear();
	let m = date.getMonth() + 1;
	let d = date.getDate();
	return [y, addZero(m), addZero(d)].join('-');
}
// 获取日期
export function getDate(offset) {
	let oneDay = 24 * 60 * 60 * 1000;
	let nowDate = new Date();
	if (typeof offset === 'number') {
		let offsetDate = new Date(nowDate.getTime() + offset * oneDay);
		return toFormat(offsetDate);
	} else {
		return toFormat(nowDate);
	}
}

/**
 * 解析 URL 参数的方法
 * @param {string} search
 * @param {string} key
 */
export function getParams(search, key) {
  if (!search) return {};
  const str = search.indexOf('?') !== -1 ? search.split('?')[1] : search;
  const params = str.split('&').reduce((args, arg) => {
    const [argKey, ...value] = arg.split('=');
    //@ts-ignore
    args[decodeURIComponent(argKey)] = decodeURIComponent(value.join('='));
    return args;
  }, {});
  //@ts-ignore
  if (key) return params[key] || '';
  return params;
}